import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-4 p-2 bg-white dark:border-gray-800 rounded-md shadow-md" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex justify-between" }

import { computed } from 'vue';
  import { Info } from '@/types';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'dealerInfo',
  props: {
    data: {}
  },
  setup(__props: any) {

  const props = __props;

  const goodSeller = computed(() => {
    return props.data.lic || props.data.renta;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "font-bold" }, "Seller :", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.data.sellerType), 1),
              (_ctx.data.lic)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["font-bold", {
              'text-green-500': goodSeller.value,
            }])
                  }, "Insurance", 2))
                : (!_ctx.data.lic && !_ctx.data.renta)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["font-bold", {
              'text-red-500': !goodSeller.value,
            }])
                    }, "Dealer", 2))
                  : (_ctx.data.renta)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: _normalizeClass(["font-bold", {
              'text-green-500': goodSeller.value,
            }])
                      }, "Rent", 2))
                    : _createCommentVNode("", true)
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-sm text-gray-700" }, " Be careful! The dealer is not a reliable person. For more information, please refer to the work chat. ", -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})